export const appBaseURL = "/"

export const appBuildAssetsDir = "/statics/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no","charset":"utf-8"},{"hid":"og:title","property":"og:title","content":"JCtrans Network-International Freight Forwarders Network"},{"hid":"og:url","property":"og:url","content":"https://m.jctrans.com/"}],"link":[{"rel":"icon","type":"image/vnd.microsoft.icon","href":"https://resources.jctrans.com/res/era/pc/img/fav.ico"},{"rel":"shortcut icon","type":"image/vnd.microsoft.icon","href":"https://resources.jctrans.com/res/era/pc/img/fav.ico"},{"rel":"icon","href":"https://resources.jctrans.com/res/era/pc/img/fav.ico"},{"rel":"preload","href":"https://resources.jctrans.com/res/era-h5/h5/img/banner.jpg","as":"image"}],"style":[],"script":[{"src":"https://resources.jctrans.com/res/jc/h5/static/js/isMobile.js","type":"text/javascript","defer":true},{"src":"https://resources.jctrans.com/res/eratracking/h5/static/js/tracking.js","type":"text/javascript","defer":true}],"noscript":[]}

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true